export const i18nNamespace = 'dreamup';
export var DreamupFormModals = /*#__PURE__*/ function(DreamupFormModals) {
    DreamupFormModals["POINTS"] = "points";
    DreamupFormModals["PROMPT_GUIDELINES"] = "prompt_guidelines";
    return DreamupFormModals;
}({});

//# sourceMappingURL=constants.js.map